// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
const styles = () => ({
  pageContainer: {
    margin: '0px',
    '@media only screen and (min-width: 1280px)': {
      margin: '0px 36px 0 36px',
    },
  },
  pageContainerDetails: {
    margin: '0px 36px 0 36px',
  },
  pageBreadCrumbClass: {
    margin: '0',
    padding: '0',
    paddingLeft: '0 !important',
  },
  pageBreadCrumbClass2: {
    margin: '36px 36px 0 36px',
  },
});

export default styles;
